// SPDX-License-Identifier: LicenseRef-Pachamama-Proprietary
// Copyright 2026 Pachamama Studios B.V. All rights reserved.

/**
 * AYNI — the speeds a dataset plays at (owner, 2026-10-20: the same five
 * as AYNI 3D). The browser's speed bar in the top corner offers each one
 * (`src/ui/playbackSpeedControl.ts`); the headset dock and the phone's AR
 * controls go round them with one button.
 */

/** The speeds offered, slowest first; 1 is normal. */
export const SPEED_STEPS = [0.25, 0.5, 1, 2, 5] as const

const EPS = 1e-3

/** Whether two speeds are the same step. */
export function sameSpeed(a: number, b: number): boolean {
  return Math.abs(a - b) < EPS
}

/** The speed after one press of a single speed button: the next step up, round the ladder (from between two steps, the one above). */
export function nextSpeed(current: number): number {
  return SPEED_STEPS.find((s) => s > current + EPS) ?? SPEED_STEPS[0]
}

/** The step nearest a speed, by ratio (a follower's trimmed 1.07 shows as 1). */
export function nearestSpeedStep(rate: number): number {
  if (!(rate > 0)) return 1
  let best: number = SPEED_STEPS[0]
  for (const s of SPEED_STEPS) {
    if (Math.abs(Math.log(s / rate)) < Math.abs(Math.log(best / rate))) best = s
  }
  return best
}

/** Whether a step is above the fastest the live layers allow (a hair of slack, so a limit of exactly 2 keeps 2). */
export function aboveCeiling(step: number, ceiling: number): boolean {
  return step > ceiling + EPS
}
